import Avatar from 'react-avatar';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState} from "react";
import Badge from "../../components/Badge";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";
import CopyToClipBoard from "../../components/CopyToClipBoard";
import NoneValue from "../../components/NoneValue";

function CreditNote({creditNote}) {
    const creditNoteUrl = creditNote.credit_note_url || null;
    const creditNoteHref = creditNoteUrl && /^https?:\/\//i.test(creditNoteUrl) ? creditNoteUrl : creditNoteUrl ? `https://${creditNoteUrl}` : null;
    const shortCreditNoteUrl = creditNote.short_credit_note_url || null;
    const shortCreditNoteHref = shortCreditNoteUrl && /^https?:\/\//i.test(shortCreditNoteUrl) ? shortCreditNoteUrl : shortCreditNoteUrl ? `https://${shortCreditNoteUrl}` : null;

    const renderCopyableLink = (url, href) => {
        if (!url) return <NoneValue />;

        return (
            <CopyToClipBoard link={href}>
                <a href={href} target="_blank" rel="noopener noreferrer">{url}</a>
            </CopyToClipBoard>
        );
    };

    const [detailsModal, setDetailsModal] = useState(false);
    const detailsModalToggle = () => {
        setDetailsModal(!detailsModal);
    };
    const [expandedProducts, setExpandedProducts] = useState(false);
    const toggleExpansion = () => {
        setExpandedProducts(!expandedProducts);
    };

    const cnStatusBadgeMap = {
        ISSUED: "badge badge-light-success",
        CANCELLED: "badge badge-light-danger",
    };

    return (
        <>
            <tr>
                <td className="invoice-pointer text-primary" onClick={detailsModalToggle}>{creditNote.credit_note_number || creditNote.id}</td>
                <td>
                    {renderCopyableLink(shortCreditNoteUrl || creditNoteUrl, shortCreditNoteHref || creditNoteHref)}
                </td>
                <td>{creditNote.original_invoice_number || '-'}</td>
                <td>{creditNote.customer_email || '-'}</td>
                <td>{creditNote.reason || '-'}</td>
                <td>INR {creditNote.total_amount}</td>
                <td>
                    <span className={creditNote.credit_note_type === 'PARTIAL' ? 'badge badge-light-warning' : 'badge badge-light-info'}>
                        {creditNote.credit_note_type || 'FULL'}
                    </span>
                </td>
                <td>
                    <Badge
                        badge={cnStatusBadgeMap[creditNote.status] || "badge badge-light-secondary"}
                        status={creditNote.status}
                    />
                </td>
                <td>{new Date(creditNote.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
            </tr>

            <Modal className={'modal-xl'} isOpen={detailsModal} toggle={detailsModalToggle}>
                <ModalHeader toggle={detailsModalToggle} close={
                    <button className="close" onClick={detailsModalToggle}>
                        &times;
                    </button>
                }>Credit Note Details</ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        <h4 className="header-title">{creditNote.merchant_business_name}</h4>
                        <p className="sub-header">
                            <Avatar size={95} name={creditNote.merchant_business_name} round/>
                        </p>
                        <div className="table-responsive">
                            <table className="table mb-0">
                                <tbody>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Credit Note ID</td>
                                    <td>{creditNote.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Credit Note Number</td>
                                    <td>{creditNote.credit_note_number || '-'}</td>
                                </tr>
                                {creditNote.credit_note_url && (
                                    <tr>
                                        <th scope="row"> </th>
                                        <td>Credit Note URL</td>
                                        <td>{renderCopyableLink(creditNoteUrl, creditNoteHref)}</td>
                                    </tr>
                                )}
                                {creditNote.short_credit_note_url && (
                                    <tr>
                                        <th scope="row"> </th>
                                        <td>Short Credit Note URL</td>
                                        <td>{renderCopyableLink(shortCreditNoteUrl, shortCreditNoteHref)}</td>
                                    </tr>
                                )}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Original Invoice Number</td>
                                    <td>{creditNote.original_invoice_number || '-'}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Original Invoice Date</td>
                                    <td>{creditNote.original_invoice_date ? new Date(creditNote.original_invoice_date).toLocaleString([], DateTimeOptionsMediumShort) : '-'}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Type</td>
                                    <td>
                                        <span className={creditNote.credit_note_type === 'PARTIAL' ? 'badge badge-light-warning' : 'badge badge-light-info'}>
                                            {creditNote.credit_note_type || 'FULL'}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Reason</td>
                                    <td>{creditNote.reason || '-'}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Customer Name</td>
                                    <td>{creditNote.customer_name}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Customer Email</td>
                                    <td>{creditNote.customer_email || '-'}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Order ID</td>
                                    <td>{creditNote.order.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Line Items</td>
                                    <td>
                                        {creditNote.line_items && creditNote.line_items.length > 0 ? (
                                            <>
                                                <div className="mb-2">
                                                    <span className="badge badge-light-primary">{creditNote.line_items.length} items</span>
                                                </div>
                                                <div className="table-responsive">
                                                    <table className="table table-sm table-bordered mb-0">
                                                        <thead className="bg-light">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Name</th>
                                                            <th>Qty</th>
                                                            <th>Rate</th>
                                                            <th>Tax %</th>
                                                            <th>Tax</th>
                                                            <th>Total</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {creditNote.line_items.map((item, index) => (
                                                            <tr key={item.id || index}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.name}</td>
                                                                <td>{item.quantity}</td>
                                                                <td>{item.rate}</td>
                                                                <td>{item.tax_percentage}%</td>
                                                                <td>{item.tax_amount}</td>
                                                                <td>{item.total_amount}</td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="mb-2">
                                                <span className="badge badge-light-primary">{creditNote.order.order_items.length} items</span>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Status</td>
                                    <td>
                                        <Badge
                                            badge={cnStatusBadgeMap[creditNote.status] || "badge badge-light-secondary"}
                                            status={creditNote.status}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Sub Total(before discount)</td>
                                    <td>INR {creditNote.sub_total_before_discount}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Discount</td>
                                    <td>INR {creditNote.discount}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Sub Total(after discount)</td>
                                    <td>INR {creditNote.sub_total_after_discount}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Tax Percentage(effective)</td>
                                    <td>{creditNote.effective_tax_percentage} %</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>CGST</td>
                                    <td>INR {creditNote.cgst}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>SGST</td>
                                    <td>INR {creditNote.sgst}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>IGST</td>
                                    <td>INR {creditNote.igst}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>UTGST</td>
                                    <td>INR {creditNote.utgst}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Total Tax</td>
                                    <td>INR {creditNote.total_tax}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Total Amount</td>
                                    <td>INR {creditNote.total_amount}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Created</td>
                                    <td>{new Date(creditNote.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Updated</td>
                                    <td>{new Date(creditNote.updated).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>

    );
}

export default CreditNote;
